import { render, staticRenderFns } from "./DetailTaxInvoiceSerialNumber.vue?vue&type=template&id=7f01912e&scoped=true&"
import script from "./DetailTaxInvoiceSerialNumber.vue?vue&type=script&lang=ts&"
export * from "./DetailTaxInvoiceSerialNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01912e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f01912e')) {
      api.createRecord('7f01912e', component.options)
    } else {
      api.reload('7f01912e', component.options)
    }
    module.hot.accept("./DetailTaxInvoiceSerialNumber.vue?vue&type=template&id=7f01912e&scoped=true&", function () {
      api.rerender('7f01912e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/taxinvoiceserialnumber/DetailTaxInvoiceSerialNumber.vue"
export default component.exports